import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  Typography,
  Box,
  IconButton,
  CircularProgress,
  Tooltip,
  Tabs,
  Tab,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";
import Iconify from "src/components/Iconify";
import { capitalCase } from "change-case";
import { string_with_limited_length } from "src/utils/common";
import { useSnackbar } from "notistack";

import { LoadingButton } from "@mui/lab";
import {
  _add_task_checklist,
  _update_task_checklist_item,
} from "src/DAL/taskChecklist";

export default function ReportTaskIssueDialog({
  open,
  setOpen,
  loadingDialog = false,
  task,
  setTask,
  setTasks,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    if (!value) {
      enqueueSnackbar("Please enter a issue", {
        variant: "error",
      });
      return;
    }

    const existingChecklist = task.check_list?.find(
      (checklist) => checklist.checklist_type === 1
    );

    setLoading(true);

    if (existingChecklist) {
      const updatedItems = [
        ...existingChecklist.items.map((item) => ({
          name: item.name,
          status: item.status,
        })),
        { name: value, status: false }, // Add new item
      ];

      const req_obj = {
        task_id: task._id,
        list_id: existingChecklist._id,
        list_item_array: updatedItems,
      };

      addListItem(req_obj);
    } else {
      // Create a new checklist if it doesn't exist
      const req_data = {
        task_id: task._id,
        name: "Task Issues List",
        checklist_type: 1,
      };

      const result = await _add_task_checklist(req_data);

      if (result.code == 200) {
        const checklistId = result.task_data.check_list?.find(
          (checklist) => checklist.checklist_type === 1
        )?._id;

        const req_obj = {
          task_id: task._id,
          list_id: checklistId,
          list_item_array: [{ name: value, status: false }],
        };

        addListItem(req_obj);
      } else {
        enqueueSnackbar(result.message, {
          variant: "error",
        });
        setLoading(false);
      }
    }
  };

  //   const handleSave = async () => {
  //     if (!value) {
  //       enqueueSnackbar("Please enter a report", {
  //         variant: "error",
  //       });
  //       return;
  //     }

  //     const req_data = {
  //       task_id: task._id,
  //       name: "Task Issues List",
  //       checklist_type: 1, // 1 issues , 2 improvements
  //     };
  //     setLoading(true);
  //     const result = await _add_task_checklist(req_data);
  //     if (result.code == 200) {
  //       const checklistId = result.task_data.check_list?.find(
  //         (checklist) => checklist.checklist_type === 1
  //       )?._id;

  //       const req_obj = {
  //         task_id: task._id,
  //         list_id: checklistId,
  //         list_item_array: [{ name: value, status: false }],
  //       };

  //       console.log(result, "xxxx");
  //       addListItem(req_obj);
  //     } else {
  //       enqueueSnackbar(result.message, {
  //         variant: "error",
  //       });
  //       setLoading(false);
  //     }
  //   };

  const addListItem = async (req_obj) => {
    const result = await _update_task_checklist_item(req_obj);
    if (result.code == 200) {
      enqueueSnackbar("Issue reported successfully", {
        variant: "success",
      });
      handleClose();
      setValue("");
      setLoading(false);
      setTask(result.task_data); //this update the task with new data
      setTasks(task?.section_id, task?._id, result.task_data);
    } else {
      enqueueSnackbar(result.message, {
        variant: "error",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth>
        {loadingDialog ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={515}
          >
            <CircularProgress disableShrink />
          </Box>
        ) : (
          <>
            <DialogTitle>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                Add Task Issue
                <IconButton size="small" onClick={handleClose}>
                  <Iconify
                    icon="ion-close"
                    sx={{
                      height: "24px",
                      width: "24px",
                    }}
                  />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent
              sx={{
                //   height: "400px",
                padding: "24px",
              }}
            >
              <div>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", pb: 1 }}>
                  Benefits of adding an issue here
                </Typography>
                <Typography className="points-issues-report">
                  <Iconify
                    icon="mingcute:check-2-fill"
                    className="points-check-icon"
                  />
                  <b>Clearer Context</b> , Issues stay tied to the main task, showing
                  how they relate.
                </Typography>
                <Typography className="points-issues-report">
                  <Iconify
                    icon="mingcute:check-2-fill"
                    className="points-check-icon"
                  />
                  <b>Less Clutter</b> , Avoids flooding the system with extra tasks.
                </Typography>
                <Typography className="points-issues-report">
                  <Iconify
                    icon="mingcute:check-2-fill"
                    className="points-check-icon"
                  />
                  <b>Centralized Communication</b> , Keeps all discussion in one place.
                </Typography>
              </div>
              <div className="pt-3">
                <TextField
                autoFocus
                  label="Explain issue here"
                  variant="outlined"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                  fullWidth
                />
              </div>
            </DialogContent>
            <DialogActions>
              <LoadingButton
                variant="contained"
                onClick={handleSave}
                loading={loading}
              >
                Report
              </LoadingButton>
              <Button variant="text" onClick={handleClose}>
                Cancel
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
